import { render, staticRenderFns } from "./appFooter.vue?vue&type=template&id=194c3280&scoped=true&"
import script from "./appFooter.vue?vue&type=script&lang=js&"
export * from "./appFooter.vue?vue&type=script&lang=js&"
import style0 from "./appFooter.vue?vue&type=style&index=0&id=194c3280&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "194c3280",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PublicLinksBlock: require('/opt/atlassian/pipelines/agent/build/frontend/apps/freelancer/components/global/publicLinksBlock.vue').default,AppLangChooser: require('/opt/atlassian/pipelines/agent/build/frontend/apps/freelancer/components/layout/appLangChooser.vue').default})
